(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sd-statistical-analysis", [], factory);
	else if(typeof exports === 'object')
		exports["sd-statistical-analysis"] = factory();
	else
		root["sd-statistical-analysis"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition